export default {
  ON_BOARDING_CUSTOMER_EMAIL_STATE_MANAGER: Symbol.for('ON_BOARDING_CUSTOMER_EMAIL_STATE_MANAGER'),
  ON_BOARDING_CUSTOMER_EMAIL_REPOSITORY: Symbol.for('ON_BOARDING_CUSTOMER_EMAIL_REPOSITORY'),
  ON_BOARDING_SEARCH_CUSTOMER_EMAILS_QUERY: Symbol.for('ON_BOARDING_SEARCH_CUSTOMER_EMAILS_QUERY'),
};
